export default __webpack_public_path__ + "static/media/08_cousin.2405c571.png";